export default __webpack_public_path__ + "static/media/RealEstateimage.3046d464.svg";